// Every image under src/assets/images, keyed by its path relative to that
// folder, resolved to its built URL. Replaces webpack's require.context.
const IMAGE_PREFIX = '../assets/images/'
const imageUrls = import.meta.glob<string>('../assets/images/**/*', {
  eager: true,
  query: '?url',
  import: 'default',
})

interface Images {
  (): {
    images: (key: string) => string
  }
}

export const useImagesContext: Images = () => ({
  images: (key: string): string =>
    imageUrls[`${IMAGE_PREFIX}${key.replace(/^\.\//, '')}`],
})
